import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/ButtonBase';
import LazyLoad from 'react-lazyload';

import TextTruncater from '../../TextTruncater';
import Currency from '../../Currency';
import CellActivitiesDetails from './Details';
import GroupTitle from '../../GroupTitle';
import SpotlioIcon from '../../Icon';

import './index.scss';

import IntlMessage from '../../../LocaleEngine';

export default function CellActivities(props) {
    const {index, element, showImages = true} = props;
    const [value, setValue] = React.useState(0);

    const openIfMobile = () => {
        props.toggleSupplier(index)
    }

    const openTab = () => {
        props.toggleSupplier(index)
        setValue(1)
    }

    function viewRooms(){
        setValue(0)
        props.toggleSupplier(index)
    }

    function handleChange(event, newValue) {
        setValue(newValue)
    }

    function handleChangeIndex(newValue) {
        setValue(newValue)
    }

    const addToCart = (element, amount, callback) => {
        props.addToCart(element, amount, callback)
    }


    function getCurrency(displayType){
        let currency = null;
        switch (displayType){
            case 1:
                currency = (
                        <Currency displayType={displayType} strikeThrough={true} onlyOriginal={true} float={true} value={element.OriginalFromPrice} />
                )
            break;
            case 2:
                currency = (
                    <React.Fragment>
                        {(element.OriginalFromPrice > 0 && element.OriginalFromPrice !== element.FromPrice) ?<Currency displayType={displayType} strikeThrough={true} onlyOriginal={true} float={true} value={element.OriginalFromPrice} /> : null}
                        <Currency onlyOriginal={true} float={true} value={element.FromPrice} />
                    </React.Fragment>
                )
            break;
            case 3:
            break;
            default:
            break;
        }
        return currency;
    }

    // we need this on API
    if (element === undefined ){
        return null;
    } else {
        let descriptionClassName = "descriptionWrap";
        if (props.configuration && props.configuration.config && props.configuration.config.showMobileDescription){
            descriptionClassName = "descriptionWrap showOnMobile"
        }
        return (
            <LazyLoad height={100} offset={100}>
                <Grid onClick={()=>openIfMobile()} key={index + 'cell'} item xs={12} className={(props.showUnspanned ? " " : props.open !== null ? props.open === index ? 'opened ' : 'closed ' : '') + "item activities"}>
                    <div className="multimedia" style={!showImages ? {'display': 'none'} : {}}>
                        <img src={element.Image.Delivery + element.Image.FileName} alt={element.ProductName} />
                    </div>
                    <div className="content">
                        <div className="titleWrap">
                            <GroupTitle element={element}/>
                        </div>
                        <div className={descriptionClassName}>
                            <Typography variant="body2" component="div" className="description">
                                <TextTruncater Function={openTab.bind(this)} text={element.Description || element.LocationDescription} sufix={'...'} limit={100} mode={'word'} />
                            </Typography>
                        </div>
                    </div>
                    <div className="pricing">
                        <React.Fragment>
                            {props.displayType ? getCurrency(props.displayType) : <Currency value={element.FromPrice} float={true} /> }
                            {!props.showUnspanned ?
                            <div className="main-cta">
                                <Button onClick={() => viewRooms()} className={(index === props.open ? "opened " : " " ) + "primary"}>
                                    <IntlMessage id="activities.cell.view_options" /> { props.open === index ? <SpotlioIcon size={16} icon={'feather-chevron-up'}/> : <SpotlioIcon size={16} icon={'feather-chevron-down'}/>}
                                </Button>
                            </div>
                            : null}
                        </React.Fragment>
                    </div>
                </Grid>
                {(index === props.open || props.onlyProduct !== undefined || props.showUnspanned ) && <CellActivitiesDetails maxQuantity={props.maxQuantity} dateOfActivity={props.dateOfActivity} isPackage={props.isPackage} displayType={props.displayType} loading={props.loading} configuration={props.configuration} showImages={showImages} compact={props.compact} value={value} handleChangeIndex={handleChangeIndex.bind(this)} handleChange={handleChange.bind(this)} addToCart={addToCart.bind(this)} index={index} element={element} />}
            </LazyLoad>
        )
    }

}
